const StepTitle = props => {
  return (
    <h1 className={`${props.className} step_title`}>{props.children}</h1>
  );
}

export default StepTitle;
